import { render, staticRenderFns } from "./recallRetrieveReportTask.vue?vue&type=template&id=556a24f0&scoped=true"
import script from "./recallRetrieveReportTask.vue?vue&type=script&lang=js"
export * from "./recallRetrieveReportTask.vue?vue&type=script&lang=js"
import style0 from "./recallRetrieveReportTask.vue?vue&type=style&index=0&id=556a24f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a24f0",
  null
  
)

export default component.exports